<template>
    <div
        class="l-ss-c-filter-container"
        :class="{ 'l-ss-c-filter-container-collapsed': isCollapsed }">
        <template v-if="shouldRenderContainer">
            <h4
                v-if="!withInnerTitle"
                @click="toggleCollapse"
                class="l-ss-c-filter-title">
                <span v-html="label"></span>
                <i v-html="iconArrowTop"></i>
            </h4>
            <collapse @change-size="$emit('change-size', $event)">
                <component
                    v-show="!isCollapsed"
                    :is="resolveFilterComponent(filter.type)"
                    :show-title="false"
                    :type="filter.name"
                    :force-show-all="false"
                    v-bind="filterCommonProps"
                    @change="params => $emit('change', params)"
                    @change-size="$emit('change-size')"
                    @filter-click="params => $emit('filter-click', params)"/>
            </collapse>
        </template>
        <template v-else>
            <component
                :is="resolveFilterComponent(filter.type)"
                :show-title="filter.type === 'checkbox'"
                v-bind="filterCommonProps"
                @change="params => $emit('change', params)"
                @filter-click="params => $emit('filter-click', params)"
                @ready="() => toggleOpen(false)"/>
        </template>
    </div>
</template>

<script>
    import * as filters from './../common/filters/filter-types';
    import cutText from '../../helpers/cut-text';

    import iconArrowTop from '@/core/assets/images/icons/arrow-top.svg';
    import Collapse from '@/core/components/collapse.vue';
    import Dropdown from '@/core/components/common/dropdown.vue';

    import firstLetterToUpperCase from '@/core/helpers/first-letter-to-upper-case';

    const LABEL_MAX_LENGTH = 30;

    export default {
        components: {
            Dropdown,
            Collapse,
        },
        filters: {
            cut(value) {
                return cutText(value, LABEL_MAX_LENGTH);
            },
        },
        props: {
            filter: {
                type: Object,
                required: true,
            },
            value: {
                type: [Object, String],
                required: false,
            },
            allCategoriesList: {
                type: Array,
            },
            isShort: {
                type: Boolean,
                default: false,
            },
            symbol: {
                type: String,
                default: '',
            },
            collapseMode: {
                type: Boolean,
                default: false,
            },
            withInnerTitle: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isCollapsed: false,
            };
        },
        computed: {
            positionLeft() {
                return this.$configuration.layout.filterPosition === 'left' && !this.$screen.isMobile;
            },
            shouldRenderContainer() {
                const filterTypes = ['m-toggle'];

                if (this.positionLeft) {
                    filterTypes.push('checkbox');
                }

                return filterTypes.includes(this.filter.type) === false;
            },
            iconArrowTop() {
                return iconArrowTop;
            },
            label() {
                const label = this.$t(`filters.byType.${this.filter.name}`);
                let resultLabel = label ? (label.label || label.title) || this.filter.name : this.filter.name;

                resultLabel = firstLetterToUpperCase(resultLabel);

                return resultLabel.replace(/\((.*?)\)/g, '<strong>($1)</strong>');
            },
            filterCommonProps() {
                return {
                    ...this.$props,
                    isShort: this.isShort,
                    symbol: this.symbol,
                };
            },
            showLabelCounter() {
                return Boolean(typeof this.value === 'object' && this.value.options instanceof Array && this.value.options.length > 0);
            },
        },
        methods: {
            resolveFilterComponent(type) {
                return filters.resolveFilterComponent(type);
            },
            toggleCollapse() {
                this.isCollapsed = !this.isCollapsed;
            },
        },
    };
</script>
